import { Box } from '@pco/atoms/Box';
import { Typography } from '@pco/atoms/Typography';
import { getDataAttrs } from '@pco/utils/getDataAttrs';
import styled from 'styled-components';

interface ProductNumberProps {
	brand?: string;
	sku: string;
}
const dataAttrs = getDataAttrs(['molecule', 'product-card']);

const ProductNumberText = styled(Typography).attrs({
	_size: 'body10',
})<{ $sku?: string | null }>(
	({ $sku, theme }) => `
	display: inline-block;
	visibility: ${$sku ? 'visible' : 'hidden'};
	color: ${theme.semanticTokens.colors.content.secondary};
`,
);

export function ProductNumber({ brand = '', sku }: ProductNumberProps) {
	return (
		<Box alignItems="center" gap="4px" {...dataAttrs('sku')()}>
			<ProductNumberText aria-hidden={!sku} $sku={sku}>
				{sku ? `${brand} #${sku}` : '\u00A0'}
			</ProductNumberText>
		</Box>
	);
}
